import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import OTPublisher from '../../../../src/OTPublisher'
import RadioButtons from './radioButtons';
import CheckBox from './checkBox';
import autoBind from 'auto-bind';
export default class Publisher extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            error: null,
            audio: true,
            video: true,
            videoSource: 'camera'
        };
    }


    setAudio(audio) {
        this.setState({ audio });
    }

    setVideo(video) {
        this.setState({ video });
    }

    setVideoSource(videoSource) {
        this.setState({ videoSource });
    }

    onError(err) {
        this.setState({ error: `Failed to publish: ${err.message}` });
    }
    disConnectCall() {
        console.log("====++++>", this.props)
        this.props.disConnectCall(this);
    }

    render() {
        console.log("this.props.session" + this.props.session)
        return (
            <div className="publishScr scriberScr">
                {this.state.error ? <div>{this.state.error}</div> : null}
                <OTPublisher
                    session={this.props.session}
                    properties={{
                        publishAudio: this.state.audio,
                        publishVideo: this.state.video,
                        videoSource: this.state.videoSource === 'screen' ? 'screen' : undefined,

                    }}
                    onError={this.onError}
                />
                <div className="pulisherBtn">
                    <RadioButtons
                        buttons={[
                            {
                                label: 'Camera',
                                value: 'camera'
                            }
                        ]}
                        initialChecked={this.state.videoSource}
                        onChange={this.setVideoSource}
                    />

                    <CheckBox
                        label="Publish Video"
                        initialChecked={this.state.video}
                        onChange={this.setVideo}
                    />
                    <CheckBox
                        label="Publish Audio"
                        initialChecked={this.state.audio}
                        onChange={this.setAudio}
                    />
                    <a onClick={this.disConnectCall.bind(this)} style={{ 'width': '30px', 'height': '30px' }}><img src={require('../../../images/images/end_call.png')} /></a>
                </div>
            </div>
        );
    }
}

{/* <CheckBox
						label="Publish Audio"
						initialChecked={this.state.audio}
						onChange={this.setAudio}
					/> */}
